import { CompanyType as ApiCompanyType } from 'src/api/generated/touring/types';
import { mapBankAccountType } from '../mapBankAccountType';
import { mapCompanySiteType } from '../mapCompanySiteType';
import type { CompanyType } from './types';

export const mapCompanyType = (apiCompany: ApiCompanyType): CompanyType => ({
  id: apiCompany.id,
  name: apiCompany.name,
  shortName: apiCompany.shortName,
  website: apiCompany.website,
  tags: apiCompany.tags,
  notes: apiCompany.notes,
  isClosePartner: apiCompany.isClosePartner,
  venueIds: apiCompany.venueIds,
  bankAccounts: apiCompany.bankAccounts.map(mapBankAccountType),
  vatId: apiCompany.vatId ?? null,
  vatRate: apiCompany.vatRate,
  isKskLiable: apiCompany.isKskLiable,
  headquarter: mapCompanySiteType(apiCompany.headquarter),
});
